import React, { useState, useEffect } from 'react';
import lightbuld from "../../assets/images/lightbulb-popup.png"
import './popup.css';

const Popup = ({ onClose }) => { 
    
    const [showActions, setShowActions] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
        setShowActions(true);
        }, 3000);

        return () => clearTimeout(timer); // evita memory leak
    }, []);

    return (
        <div className="popup-backdrop">
            <div className="popup-container">
                { showActions && ( <button className="popup-close" onClick={onClose}>×</button> )}
                <div className="popup-header">
                    <img src={lightbuld} alt="icon" className="popup-icon" />
                    <h2>Nova forma de acessar!</h2>
                </div>
                <p className="popup-text">
                    Acesse o Catch Up com seu login e senha do{' '}
                    <span className="wizme-wiz">WIZ</span>
                    <span className="wizme-me">ME</span>
                    {' '}e siga evoluindo com mais praticidade.
                </p>
                <p className="popup-text-bold">Seu login antigo também continua ativo.</p>
                { showActions && ( <button className="popup-button" onClick={onClose}>Entendi!</button> )}
            </div>
        </div>
    );
}

export default Popup
